var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-tabs', {
    attrs: {
      "nav-class": "v-nav",
      "pills": "",
      "vertical": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Head",
      "active": ""
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.head,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Hair"
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.hair,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Facial Hair"
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.facialHair,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }